import logo from './logo.png';
import React from 'react';  
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';  
import './App.css';  
import Home from './Home'; // Import the Home page  
// import Courses from './Courses'; // Import the Courses page  
import Contact from './Contact'; // Import the Contact page  
import TermsAndConditions from './TermsAndConditions'; // Import the Terms & Conditions page  

  
function App() {  
  return (  
    <Router>  
      <div className="app-container">  
        {/* Header Section */}  
        <header className="header">  
          <img src={logo} alt="Logo" className="logo" />  
          <div>
          <h1 className="company-name">Sure Steps Learning</h1> {/* Website Name */}
          <h2 className="tagline">Your staircase to academic success!</h2> {/* Tagline */}
          <h2 className="tagline2">From Perth to the East Coast</h2> 
          </div>
          <nav className="menu">  
            <Link to="/" className="menu-item">Home</Link>  
            {/* <Link to="/courses" className="menu-item">Courses</Link>   */}
            <Link to="/contact" className="menu-item">Contact Us</Link>  
            <Link to="/terms" className="menu-item">T & Cs</Link>  
          </nav>  
        </header>  
  
        {/* Routes */}  
        <Routes>  
          <Route path="/" element={<Home />} />  
          {/* <Route path="/courses" element={<Courses />} />   */}
          <Route path="/contact" element={<Contact />} />  
          <Route path="/terms" element={<TermsAndConditions />} />  
        </Routes>  
        <div className="footer">Best viewed in landscape orientation when using a mobile device.</div>
      </div>  
    </Router>  
  );  
}  
  
export default App;  